<template>
  <v-row>
    <div class="col">
      <div class="popular-comments">
        <h4>{{ $t("Самые популярные комментарии") }}</h4>
        <div class="bg-white">
        <ul v-if="statistics.popularComments">
          <li v-for="{ comment, cnt, npa, npaVersion, npaVersionBlock } in statistics.popularComments" :key="comment.id">
            <div class="comment-icon">
              <img alt="checkmark" src="@/assets/checkmark.jpg">
              {{ cnt }}
            </div>
            <div>
              <router-link
                :title="comment.text | strippedContent"
                active-class="active"
                :to="$i18nRoute({
                  name: 'view-npa',
                  params: { id: npa.id },
                  query: { comment: comment.id, ver:npaVersion, block: npaVersionBlock}
                })"
                :key="comment.id"
              >
                {{ comment.text | strippedContent | splitTextIntoLines(4, 32) }}
              </router-link>
            </div>
          </li>
        </ul>
      </div>
      </div>
    </div>
    <div class="col">
      <div class="popular-user">
        <h4>{{ $t("ТОП - пользователей") }}</h4>
        <div class="bg-white">
          <ul>
            <li v-for="{ user, cnt } in statistics.activeUsers" :key="user.id">
              <template v-if="user.nick_name">
                {{ user.nick_name }}
              </template>
              <template v-else-if="user.email">
                {{ user.email }}
              </template>
              <template v-else>
                {{ user.second_name }} {{ user.first_name }}
              </template>
              <span>({{ cnt }})</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="col">
      <div class="popular-organs">
        <h4>{{ $t("Активные госорганы") }} <strong>{{ $t("по количеству ответов на комментарии") }}</strong></h4>
        <div class="bg-white">
          <ul>
            <li v-for="{ developer, cnt } in statistics.popularDevelopersCommentAnswers" :key="developer.id">
              {{ developer.transName }} <span>({{ cnt }})</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </v-row>
</template>

<script>
  import NPA from '@/model/npa'

  export default {
    data: () => ({
      statistics: [],
    }),
    mounted() {
      NPA.getPopularStatistics()
        .then((response) => {
          this.statistics = response.data
          // console.log('statistics', this.statistics)
        })
        .catch((error) => {
          //@todo ошибки
        })
    },
  }
</script>

<style scoped>

</style>
